<template>
  <d2-container>
    <div class="login-container">
      <div class="loginbasecont">
        <div class="logincontLft">
          <div class="loginconttitle"></div>
          <div class="logincontCon1">欢迎您登录算力城市云平台</div>
          <div style="height: 32px;" />
          <div class="logincontCon3">智能计算 + 高速网络 + 高速分布式存储</div>
          <div class="logincontCon3">集计算、开发、科研于一体</div>
        </div>

        <el-card class="box-card">
          <template>
            <div class="card-header">
              <span>算力城市云平台</span>
            </div>
          </template>
          <el-form :model="form" status-icon :rules="rules" ref="ruleForm" style="margin:0 30px;" class="demo-ruleForm">
            <el-form-item prop="username">
              <el-input v-model="form.username" placeholder="请输入用户名"></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input type="password" v-model="form.password" autocomplete="off" placeholder="请输入密码"></el-input>
            </el-form-item>
            <el-form-item style="margin-top:110px;">
              <el-button type="primary" class="login-btn" @click="submitForm('ruleForm')" >
                <span>登录</span>
              </el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </div>
    </div>
  </d2-container>
</template>

<script>
// import { Base64 } from 'js-base64'
import { aesEncrypt } from '@/utils/crypto'


export default {
  name: 'hosting',
  data() {
    return {
      form: {
        username: '',
        password: ''
      },
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log('[submitForm]', this.form.username, this.form.password)
          // let pwCode = Base64.encode(this.form.password)
          const pwCode = aesEncrypt(this.form.password)
          console.log('[submitForm]', pwCode)

          this.$axios({
            method: 'post',
            url: '/service/auth',
            //url: 'https://lthpc.atcloud.xyz:30300/api/v1/auth/login',
            data: {
              username: this.form.username,
              password: pwCode
            }
          }).then(res => {
            console.log("[submitForm - response]", res)
            if (res.code === 200) {
              console.log("[submitForm]: Success!")
            }
          })

          // this.$axios({
          //   method: 'get',
          //   url: 'https://lthpc.atcloud.xyz/api/v1/auth/regions'
          // }).then(res => {
          //   console.log('[submitForm - regions]', res)
          // })

        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: url(/image/portalimg/loginin.png) no-repeat;
  background-size: 100% 100%;
}
.loginbasecont{
  width:1560px;
  height: 100vh;
  margin:0 auto;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}
.logincontLft{
  width: 766px;
  float: left;
  margin-right: 200px;
}
.loginconttitle{
  font-size: 24px;
  color: #05004B;
  letter-spacing: 2.8px;
  line-height: 86px;
  font-weight: 400;
}
.logincontCon1{
  font-size: 48px;
  color: #05004B;
  letter-spacing: 2.8px;
  line-height: 86px;
  font-weight: 500;
}
.logincontCon2{
  font-size: 48px;
  color: #05004B;
  letter-spacing: 2.8px;
  line-height: 86px;
  font-weight: 500;
}
.logincontCon3{
  font-size: 24px;
  color: #05004B;
  letter-spacing: 2.8px;
  line-height: 48px;
  font-weight: 400;
}

.box-card {
  width: 420px;
  height: 500px;
  float: right;
}
.card-header{
  text-align: center;
  padding: 60px 0;
}
.card-header span{
  font-size: 24px;
  color: #000000;
  letter-spacing: 4px;
  font-weight: 600;
}
.login-btn{
  width:340px;
  border-radius:100px;
  color: #fff !important;
}
.login-btn span{
  color: #fff !important;
}


</style>
